import { getToken } from './tokenProvider';

const origin = window.location.origin;
export const API_BASE = `${origin}/api`;

// Strip the `/api` suffix so we can hit static assets like /uploads/sounds/...
export const API_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

async function logFailedResponse(res, url, options = {}) {
  let bodyPreview = '';

  try {
    bodyPreview = (await res.clone().text()).slice(0, 500);
  } catch {
    bodyPreview = '<unavailable>';
  }

  console.error('[apiFetch] Request failed', {
    url,
    method: options.method || 'GET',
    status: res.status,
    statusText: res.statusText,
    contentType: res.headers.get('content-type'),
    bodyPreview,
  });
}

/**
 * Wrapper for fetch() with JWT token support.
 */
export async function apiFetch(endpoint, options = {}) {
  const token = await getToken();

  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  // Only set JSON Content-Type if we're NOT sending FormData
  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const url = `${API_BASE}${endpoint}`;
  let res;

  try {
    res = await fetch(url, {
      ...options,
      headers,
    });
  } catch (err) {
    console.error('[apiFetch] Network error', {
      url,
      method: options.method || 'GET',
      message: err?.message || String(err),
    });
    throw err;
  }

  if (res.status === 401) {
    console.warn('Unauthorized - token missing/expired');
  }

  if (!res.ok) {
    await logFailedResponse(res, url, options);
  }

  return res;
}
